import { lazy } from 'react';

const PersonalDetailsPage = lazy(() =>
  import('../pages/happyFlowPages/personalDetails/PersonalDetails.tsx').then(
    ({ PersonalDetails }) => ({
      default: PersonalDetails,
    })
  )
);
const PhonePage = lazy(() =>
  import('../pages/happyFlowPages/phone/Phone.tsx').then(({ Phone }) => ({ default: Phone }))
);

const IdentityPage = lazy(() =>
  import('../pages/happyFlowPages/identity/Identity.tsx').then(({ Identity }) => ({
    default: Identity,
  }))
);

const HomeAddressPage = lazy(() =>
  import('../pages/happyFlowPages/homeAddress/HomeAddress.tsx').then(({ HomeAddress }) => ({
    default: HomeAddress,
  }))
);

const PlanSelectionPage = lazy(() =>
  import('../pages/happyFlowPages/planSelection/PlanSelection.tsx').then(({ PlanSelection }) => ({
    default: PlanSelection,
  }))
);

const KnowYourBusinessPage = lazy(() =>
  import('../pages/happyFlowPages/knowYourBusiness/KnowYourbusiness.tsx').then(
    ({ KnowYourbusiness }) => ({
      default: KnowYourbusiness,
    })
  )
);

const BusinessTypeSelectionPage = lazy(() =>
  import('../pages/happyFlowPages/businessTypeSelection/BusinessTypeSelection.tsx').then(
    ({ BusinessTypeSelection }) => ({ default: BusinessTypeSelection })
  )
);

const IndustryPage = lazy(() =>
  import('../pages/happyFlowPages/industry/Industry.tsx').then(({ Industry }) => ({
    default: Industry,
  }))
);

const IndustryOldPage = lazy(() =>
  import('../pages/happyFlowPages/industryOld/Industry.tsx').then(({ Industry }) => ({
    default: Industry,
  }))
);

const SuccessPage = lazy(() =>
  import('../pages/success/Success.tsx').then(({ Success }) => ({
    default: Success,
  }))
);

const ReviewPage = lazy(() =>
  import('../pages/happyFlowPages/reviewPage/Review.tsx').then(({ Review }) => ({
    default: Review,
  }))
);

const DebitCardNamePage = lazy(() =>
  import('../pages/debitCardName/DebitCardName.tsx').then(({ DebitCardName }) => ({
    default: DebitCardName,
  }))
);

const GenericMessage = lazy(() =>
  import('../pages/genericMessagePage/GenericMessage.tsx').then(({ GenericMessagePage }) => ({
    default: GenericMessagePage,
  }))
);

const SocureDocV = lazy(() =>
  import('../pages/happyFlowPages/socureDocv/SocureDocV.tsx').then(
    ({ SocureDocV: SocureDocVPage }) => ({
      default: SocureDocVPage,
    })
  )
);
const UnderReview = lazy(() =>
  import('../pages/happyFlowPages/underReview/UnderReview.tsx').then(
    ({ UnderReview: UnderReviewPage }) => ({
      default: UnderReviewPage,
    })
  )
);

const KycFailed = lazy(() =>
  import('../pages/kycFailed/KycFailed.tsx').then(({ KycFailed: KycFailedPage }) => ({
    default: KycFailedPage,
  }))
);

const EmailVerification = lazy(() =>
  import('../pages/happyFlowPages/emailVerification/EmailVerification.tsx').then(
    ({ EmailVerification: EmailVerificationPage }) => ({
      default: EmailVerificationPage,
    })
  )
);

const AutoLogin = lazy(() =>
  import('../pages/autoLogin/AutoLoginPage.tsx').then(({ AutoLoginPage }) => ({
    default: AutoLoginPage,
  }))
);
const OneOfUs = lazy(() =>
  import('../pages/oneOfUs/OneOfUs.tsx').then((module) => ({
    default: module.OneOfUs,
  }))
);

export {
  PhonePage,
  IdentityPage,
  PersonalDetailsPage,
  HomeAddressPage,
  KnowYourBusinessPage,
  BusinessTypeSelectionPage,
  IndustryPage,
  IndustryOldPage,
  PlanSelectionPage,
  ReviewPage,
  SuccessPage,
  DebitCardNamePage,
  GenericMessage,
  SocureDocV,
  UnderReview,
  OneOfUs,
  KycFailed,
  EmailVerification,
  AutoLogin,
};
